// API configuration for backend integration
export const API_CONFIG = {
  // Replace with your actual backend API URL
  BASE_URL: 'https://clip-sense-platform-380511447595.us-central1.run.app/api/v1',
  
  // Feature flags to control which APIs to use
  USE_REAL_UPLOAD: true,
  USE_REAL_VIDEO_LIST: true,
  USE_REAL_PLAYBACK: true,
  
  // Pagination defaults
  DEFAULT_PAGE_SIZE: 20,
  
  // Upload settings
  UPLOAD_TIMEOUT: 5 * 60 * 1000, // 5 minutes
};

// Helper to get authorization headers with Supabase token
export const getAuthHeaders = (token: string) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json',
});

// Helper for API error handling
export const handleApiError = async (response: Response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `API Error: ${response.status}`);
  }
  return response;
};
